import {useState} from "react";
import useErrorHandler from "./use-error-handler";
import axios from "axios";
import {
    getDeleteSpaceMediaUrl, getHomeSpaceMediaPagedUrl,
    getHomeSpaceMediaUrl,
    getPeekGallerySpacesBySpaceUrl,
    getPeekGallerySpacesUrl,
    getPeekPublicGallerySpacesUrl, getPublicHomeSpaceMediaPagedUrl,
    getPublicHomeSpaceMediaUrl, getPublicSpaceMediaPagedUrl,
    getPublicSpaceMediaUrl, getSpaceMediaPagedUrl,
    getSpaceMediaUrl
} from "../../actions/environment";
import {authConfig} from "../../actions/local-storage";
import {ACTIVE_PEEK_MODE, PENDING_STATUS, SUCCESS_STATUS} from "../../actions";
import {useAuthorization, useGenericSpaces} from "../../selectors";

// -- ACHTUNG spaceMedia might hold paged media and media as a list which might cause big trouble --
// -- requires refactoring or deletion of calls returning lists in favor of paged media only --
// -- more importantly, the server returns SpaceMedia whereas it should consistently return a Media object
// -- this refactoring is marked on the server side for completion --

const useFetchGallery = () => {
    const [status, setStatus] = useState('none');
    const [spaces, setSpaces] = useState([]);
    const [spaceMedia, setSpaceMedia] = useState(null);
    const {isAuthorized} = useAuthorization();
    const {media: postMedia, member} = useGenericSpaces();
    const {handleError, error} = useErrorHandler(setStatus);

    // fetch gallery peek spaces ie any active gallery space for that user
    // refactor to fetchGalleriesByUser
    const fetchGallerySpaces = (username, callback) => {
        const url = isAuthorized ? getPeekGallerySpacesUrl(username, ACTIVE_PEEK_MODE)
            : getPeekPublicGallerySpacesUrl(username, ACTIVE_PEEK_MODE)

        setStatus(PENDING_STATUS);
        axios.get(url, authConfig())
            .then(response => {
                setSpaces(response.data);
                callback && callback(response.data);
                setStatus(SUCCESS_STATUS);
            })
            .catch(error => {
                handleError(error, () => fetchGallerySpaces(username, callback));
            })
    }

    // authorized users only - fetches galleries specific to a group space
    const fetchGalleriesBySpace = (username, spaceId, callback) => {
        const url = getPeekGallerySpacesBySpaceUrl(username, spaceId);

        setStatus(PENDING_STATUS);
        axios.get(url, authConfig())
        .then(response => {
            setSpaces(response.data);
            callback && callback(response.data);
            setStatus(SUCCESS_STATUS);
        })
        .catch(error => {
            handleError(error, () => fetchGalleriesBySpace(username, spaceId, callback));
        })
    }

    // media is of type media and corresponds to all images in the home space postings of the user
    const fetchHomeSpaceMedia = (username, spaceId, callback) => {
        const url = isAuthorized ? getHomeSpaceMediaUrl(username) : getPublicHomeSpaceMediaUrl(username)

        setStatus(PENDING_STATUS);
        axios.get(url, authConfig())
        .then(response => {
            setSpaceMedia(response.data);
            callback && callback(response.data);
            setStatus(SUCCESS_STATUS);
        })
        .catch(error => {
            handleError(error, () => fetchSpaceMedia(username, spaceId, callback));
        })
    }

    // same as above but returns page object initialized
    const fetchHomeSpaceMediaPaged = (username, spaceId, mediatype, page, size, callback) => {
        const url = isAuthorized
            ? getHomeSpaceMediaPagedUrl(username, mediatype, page, size)
            : getPublicHomeSpaceMediaPagedUrl(username, mediatype, page, size);

        setStatus(PENDING_STATUS);
        axios.get(url, authConfig())
        .then(response => {
            setSpaceMedia(response.data);
            callback && callback(response.data);
            setStatus(SUCCESS_STATUS);
        })
        .catch(error => {
            handleError(error, () => fetchHomeSpaceMediaPaged(username, spaceId, mediatype, page, size, callback));
        })
    }

    // media is of type space media usually a custom user gallery
    const fetchSpaceMedia = (username, spaceId, callback) => {
        const url = isAuthorized ? getSpaceMediaUrl(username, spaceId) : getPublicSpaceMediaUrl(username, spaceId)

        setStatus(PENDING_STATUS);
        axios.get(url, authConfig())
            .then(response => {
                setSpaceMedia(response.data);
                callback && callback(response.data);
                setStatus(SUCCESS_STATUS);
            })
            .catch(error => {
                console.log('Fetch gallery media error', spaceId, error);
                handleError(error, () => fetchSpaceMedia(username, spaceId, callback));
            })
    }

    // same as above but with page object initialized
    const fetchSpaceMediaPaged = (username, spaceId, mediatype, page, size, callback) => {
        const url = isAuthorized
            ? getSpaceMediaPagedUrl(username, spaceId, mediatype, page, size)
            : getPublicSpaceMediaPagedUrl(username, spaceId, mediatype, page, size);

        setStatus(PENDING_STATUS);
        axios.get(url, authConfig())
        .then(response => {
            setSpaceMedia(response.data);
            callback && callback(response.data);
            setStatus(SUCCESS_STATUS);
        })
        .catch(error => {
            console.log('Fetch paged gallery media', spaceId, error);
            handleError(error, () => fetchSpaceMediaPaged(username, spaceId, mediatype, page, size, callback));
        })
    }

    const filterPagedMediaById = id => {
        const media = spaceMedia.page.content.filter(media => media.id !== id);
        setSpaceMedia({...spaceMedia, page: {...spaceMedia.page, content: media}})
    }

    const deleteSpaceMedia = (username, mediaId, callback) => {
        setStatus(PENDING_STATUS);
        axios.delete(getDeleteSpaceMediaUrl(username, mediaId), authConfig())
            .then(response => {
                filterPagedMediaById(response.data.id);
                // setSpaceMedia(response.data);
                callback && callback(response.data);
                setStatus(SUCCESS_STATUS);
            })
            .catch(error => {
                handleError(error, () => deleteSpaceMedia(username, mediaId, callback));
            })
    }

    return {
        // refactor to fetchGalleriesByUser
        fetchGallerySpaces: fetchGallerySpaces,
        fetchGalleriesBySpace: fetchGalleriesBySpace,
        fetchHomeSpaceMedia: fetchHomeSpaceMedia,
        fetchHomeSpaceMediaPaged: fetchHomeSpaceMediaPaged,
        fetchSpaceMedia: fetchSpaceMedia,
        fetchSpaceMediaPaged: fetchSpaceMediaPaged,
        deleteSpaceMedia: deleteSpaceMedia,
        spaces: spaces, postMedia: postMedia, spaceMedia: spaceMedia, status: status, error: error
    }
}

export default useFetchGallery;